import {IBrowser, UAParser} from 'ua-parser-js';

enum supportedBrowsers {
  'Mobile Chrome' = 120,
  Chrome = 120,
  Firefox = 120,
  Edge = 120,
  Safari = 16,
  Facebook = 1, //Default to version of 1 so any in-app browser passes
  Instagram = 1 //Default to version of 1 so any in-app browser passes
}

const checkBrowserSupport = (browser: IBrowser) => {
  const browserVersion = Number(browser.version?.split('.')[0]);

  return Object.entries(supportedBrowsers).some(
    ([key, value]) => isNaN(Number(key)) && key === browser.name && browserVersion >= Number(value)
  );
};

export const isBrowserAndDeviceSupported = () => {
  const parser = new UAParser();

  const userAgent = parser.getResult();

  const isIOS = userAgent.os.name === 'iOS';

  //All browsers on iOS use webkit, requiring Iphone and Ipads so use safari 16 or higher
  return {
    isBrowserSupported: !isIOS ? checkBrowserSupport(userAgent.browser) : true,
    isIOSSupported: isIOS
      ? checkBrowserSupport({...userAgent.browser, name: 'Safari', version: userAgent.os.version})
      : true
  };
};

export const isIphone = () => {
  const deviceType = new UAParser().getDevice().model;
  return !!deviceType && /iPhone/gi.test(deviceType);
};

export const isAndroid = () => {
  const OS = new UAParser().getOS().name;
  return !!OS && /android/gi.test(OS);
};
